<template>
    <div>
        <v-alert :value="requestFailed" type="error" outline class="mt-4">
            <span>{{requestErrorMessage}}</span>
        </v-alert>
        <v-card-title primary-title>
            <div>
                <div class="headline">Add Team Member</div>
            </div>
        </v-card-title>
        <v-card-text>
            <v-layout row>
                <v-flex xs12 md6>
                    <loading v-if="submitting" loadingMessage="Adding team member..."></loading>
                    <template v-else>
                        <team-add-form :systemConfig="systemConfig"
                                      cancelButtonText="Cancel"
                                      @update="formUpdated"
                                      @submitted="formSubmitted"
                                      @cancelled="formCancelled"
                                      submitButtonText="Add New Team Member"></team-add-form>
                    </template>
                </v-flex>
            </v-layout>
        </v-card-text>
        <cancel-form-warning @abort="resetWaring" @confirm="cancel" :warnDialog="warnDialog"></cancel-form-warning>
    </div>
</template>

<script>
  import TeamAddForm from '@/forms/team/TeamAddForm'
  import CancelFormWarning from '@/views/app/elements/CancelFormWarning'
  import {CrudFormMixin} from '@/views/app/company/crud/crud-mixins'

  export default {
    name: 'CompanyAddTeamMember',
    mixins: [CrudFormMixin],
    components: {
      TeamAddForm,
      CancelFormWarning
    },
    props: {
      systemConfig: {
        type: Object,
        required: true
      }
    },
    data: () => ({}),
    computed: {
      apiPath () {
        return `/admin/company/${this.existingData.uid}/team`
      }
    },
    methods: {
      handleSuccess(response) {
        const self = this
        self.submitting = false
        self.$notifications.$emit('toast', {text: 'Successfully saved your changes!', colour: 'success', buttonColour: ''})
        console.log(`[${self.formName}]: Successfully submitted: ${response}`)
        self.$router.push({name: 'admin.company.team', params: {uid: this.existingData.uid}})
      }
    }
  }
</script>

<style scoped>

</style>